module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.show) ? _c('div', {
    ref: "wxc-cover",
    staticClass: "g-cover weex-ct weex-div",
    style: (_vm._px2rem(_vm.coverStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.hideAction($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show && _vm.buttons.length) ? _c('div', {
    ref: "wxc-popover",
    staticClass: "g-popover weex-ct weex-div",
    style: (_vm._px2rem(_vm.contentStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "u-popover-arrow weex-ct weex-div",
    style: (_vm._px2rem(_vm.arrowStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-popover-inner weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.buttons), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: " weex-ct weex-div",
      class: ['i-btn', i === _vm.buttons.length - 1 ? 'i-btn-noborder' : ''],
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.wxcButtonClicked(i, item.key)
        }
      }
    }, [(item.icon) ? _c('figure', {
      staticClass: "btn-icon weex-el weex-image",
      attrs: {
        "src": item.icon,
        "data-img-src": item.icon,
        "weex-type": "image"
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "btn-text weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.textStyle, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.text))])])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db49c5f8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db49c5f8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-popover/index.vue
// module id = 243
// module chunks = 0 1